'use client';

import {useCallback, useRef} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Navigation, Pagination} from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import SwiperNav from '../SwiperNav/SwiperNav';

import LeadersItem from './LeadersItem/LeadersItem';
import leaders from 'data/leaders';

const Leaders = () => {
  const swiper = useRef();

  const forward = useCallback(() => swiper.current.slideNext(), [swiper]);
  const back = useCallback(() => swiper.current.slidePrev(), [swiper]);

  const sliderItems = leaders.concat(leaders).map((item, index) => {
    return (
      <SwiperSlide key={index} virtualIndex={index}>
        <LeadersItem data={item} />
      </SwiperSlide>
    );
  });

  const swiper_opts = {
    id: 'security-slider',
    modules: [Navigation, Pagination],
    spaceBetween: 32,
    slidesPerView: 3,
    speed: 300,
    centeredSlides: false,
    watchOverflow: false,
    modules: [Navigation],
    loop: true,
    loopPreventsSliding: false,
    autoplay: true,
    onSwiper: inst => swiper.current = inst
  };

  return (
    <section className='leaders'>
      <div className='container'>
        <h3 className='subtitle'>Our leaders</h3>
        <h2 className='title'>We love what we do</h2>
        <p className='text'>
          Our leadership team has decades of collective experience in cybersecurity, software engineering, and technology management, bringing a diverse set of backgrounds and perspectives to the table.
        </p>
        <div className='slider-wrapper'>
          <div className='slider'>
            <Swiper {...swiper_opts}>
              {sliderItems}
            </Swiper>
          </div>
        </div>
        <div className='slider-nav'>
          <SwiperNav onPrevClick={back} onNextClick={forward}/>
        </div>
      </div>
    </section>
  );
};

export default Leaders;

